import * as React from 'react'

import { Box, Divider, Text, Title } from '@factorialco/deprecated-design-system'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import { usePerDiemWizard } from 'modules/expenses/components/expenses/New/PerDiemWizard/form/context'
import { CostCenterAssignment } from 'modules/expenses/components/expenses/New/PerDiemWizard/form/types'

interface CostCenterOption {
  id: number
  name: string
}

interface CostCentersProps {
  costCenterOptions: CostCenterOption[]
  loading?: boolean
}

const CostCenters = ({ costCenterOptions, loading }: CostCentersProps) => {
  const { data, updateData } = usePerDiemWizard()

  const handleCostCenterChange = (value?: string) => {
    if (!value) {
      updateData({ costCenterAssignments: [] })
      return
    }

    // For now, single cost center with 100% allocation
    const isoString = data.startDate?.toISOString() ?? new Date().toISOString()
    const startDate = isoString.split('T')[0] || isoString
    const assignment: CostCenterAssignment = {
      costCenterId: Number(value),
      percentage: 100,
      startDate,
    }
    updateData({ costCenterAssignments: [assignment] })
  }

  const selectOptions = costCenterOptions.map((cc) => ({
    label: cc.name,
    value: cc.id.toString(),
  }))

  const currentValue = data.costCenterAssignments[0]?.costCenterId?.toString()

  if (costCenterOptions.length === 0 && !loading) {
    return null
  }

  return (
    <Box flexDirection="column" gap="s16">
      <Box flexDirection="column" gap="s4">
        <Title
          variant="400"
          title={i18n.t('expenses_v2.forms.new_form.blocks.cost_center_information')}
        />
        <Text.Normal size="200" color="grey800">
          {i18n.t('expenses_v2.forms.new_form.blocks.cost_center_information_description')}
        </Text.Normal>
      </Box>

      <Box flexDirection="column" gap="s4">
        <Text.Normal size="200" weight="medium" color="grey1000">
          {i18n.t('expenses_v2.forms.fields.cost_centers.label')}
        </Text.Normal>
        <Select
          none={i18n.t('common.select')}
          options={selectOptions}
          value={currentValue}
          onChange={handleCostCenterChange}
          readonly={loading}
        />
      </Box>

      <Box paddingTop="s8" paddingBottom="s8">
        <Divider vertical={false} />
      </Box>
    </Box>
  )
}

export default CostCenters
